import React, { useRef,  useState, useCallback } from 'react';
import List from '../grid.component';
import { CardNumberHandlerColumnHandler, DateColumnHandler, NumberFormatter, StatusColumnHandler, TransactionsIdColumnHandler } from './service';
import { badge } from 'src/utils/statusColorsCode';

const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
    return <NumberFormatter value={value} />;
  };

const Grid = ((props, ref) => {
  const gridRef = useRef(null);
  const [copied, setCopied] = useState('')
  const [copiedId, setCopiedId] = useState('');
  const handleCopy = useCallback((id) => {
    setCopied(id);
    setTimeout(() => {
      setCopied('');
    }, 1000)
  },[])
  const handleIdCopy = useCallback((id) => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  },[])

    const idColumnHandler = (props) => { return (<TransactionsIdColumnHandler data={props} copiedId={copiedId} handleIdCopy={handleIdCopy}/>) }
    const cardNumberHandler = (props) => { return (<CardNumberHandlerColumnHandler data={props} copied={copied} handleCopy={handleCopy}/>) }
    const dateColumnHandler = (props) => { return (<DateColumnHandler data={props} />) }
    const statusColumnHandler = (props) => {  return (<StatusColumnHandler data={props} badge={badge}/>)}

  const customcells = {
      "tradeId": idColumnHandler,
      "cardNumber": cardNumberHandler,
      "tradeAmount": renderNumberColumn("tradeAmount"),
      "fee": renderNumberColumn("fee"),
      "walletBefore": renderNumberColumn("walletBefore"),
      "walletAfter": renderNumberColumn("walletAfter"),
      "createdDate":dateColumnHandler,
      "state":statusColumnHandler
    };

    const renderCustomCell = useCallback((props, column) => {
      if (customcells[column.field]) {
        return customcells[column.field](props);
      }
    },[copied,copiedId])

  return (
    <div className="mt-4">
      <List
        pSize={10}
        url={process.env.REACT_APP_GRID_API + `api/CardsActivityService/Activity/Transactions`}
        additionalParams={props?.filterValues}
        ref={gridRef}
        className="custom-grid"
        renderCustomCell={renderCustomCell}
        showExcelExport={props?.isExcelExport} pKey={"Operations"} screenName={"Operations"}/>
    </div>
  );
})
export default Grid;
